import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "col-xl-4 order-xl-2 mb-5 mb-xl-0 mt-6"
};
var _hoisted_2 = {
  "class": "card card-profile shadow"
};

var _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"row justify-content-center\"><div class=\"col-lg-3 order-lg-2\"><div class=\"card-profile-image\"><a href=\"#\"><img src=\"img/theme/luckynumairdrop.png\" class=\"rounded-circle\"></a></div></div></div>", 1);

var _hoisted_4 = {
  "class": "card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4"
};
var _hoisted_5 = {
  "class": "d-flex justify-content-between"
};
var _hoisted_6 = {
  "class": "card-body pt-0 pt-md-4"
};
var _hoisted_7 = {
  "class": "row"
};
var _hoisted_8 = {
  "class": "col"
};
var _hoisted_9 = {
  "class": "card-profile-stats d-flex justify-content-center mt-md-5"
};
var _hoisted_10 = {
  "class": "heading"
};
var _hoisted_11 = {
  "class": "description"
};
var _hoisted_12 = {
  "class": "text-left"
};

var _hoisted_13 = /*#__PURE__*/_createElementVNode("hr", {
  "class": "my-4"
}, null, -1);

var _hoisted_14 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_base_button = _resolveComponent("base-button");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_base_button, {
    size: "sm",
    type: !$data.airDropInfo ? 'secondary' : !$data.airDropInfo.isClaimed ? 'info' : 'secondary',
    "class": "mr-4",
    onClick: $options.claimedAirDrop
  }, {
    "default": _withCtx(function () {
      return [_createTextVNode(_toDisplayString(!$data.airDropInfo ? _ctx.$t("button.checking") : !$data.airDropInfo.isClaimed ? _ctx.$t("button.claim") : _ctx.$t("button.claimed")), 1)];
    }),
    _: 1
  }, 8, ["type", "onClick"]), _createVNode(_component_base_button, {
    size: "sm",
    type: "default",
    "class": "float-right",
    onClick: $options.goToRank
  }, {
    "default": _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t("button.rank")), 1)];
    }),
    _: 1
  }, 8, ["onClick"])])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_10, _toDisplayString($data.isLogin ? $data.airDropInfo ? $data.airDropInfo.airDropPrize : 0 : _ctx.$t("label.pleaseLogin")), 1), _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("label.myAirDrop")), 1)])])])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t("label.deadline")) + "： " + _toDisplayString($props.steemLuckNumAirDrop.endTime), 1), _hoisted_13, _createElementVNode("p", {
    innerHTML: $props.steemLuckNumAirDrop.rule
  }, null, 8, _hoisted_14)])])])]);
}